export const watchFormFields = function( formTextInputs ) {
  
  if ( formTextInputs ) {

    formTextInputs.forEach( ( elem ) => {

      const parentWrap = elem.closest( ".has-label-shift" );
      const className  = "has-shifted-label";
      const elemVal    = elem.value.trim();
  
      // fields in need of validation get the style no matter what
      if ( parentWrap.classList.contains( "gfield_error" ) ) {
        
        parentWrap.classList.add( className );

      // otherwise watch fields to see if they have a value and
      // apply the class accordingly
      } else {

        // if this is a complex field
        if ( document.activeElement.closest( ".ginput_complex" ) !== null ) {
          return
        }

        if ( document.activeElement.closest( ".has-label-shift" ) === parentWrap || elemVal !== "" ) {
        
          parentWrap.classList.add( className );
        
        } else {

          parentWrap.classList.remove( className );
        
        }

      }

    });
    
  }

}